import { api } from '../../../lib/api'

export const GET_TIMELINE_BY_PRODUCT_REQUEST = 'GET_TIMELINE_BY_PRODUCT_REQUEST'
export const GET_TIMELINE_BY_PRODUCT_SUCCESS = 'GET_TIMELINE_BY_PRODUCT_SUCCESS'
export const GET_TIMELINE_BY_PRODUCT_FAILED = 'GET_TIMELINE_BY_PRODUCT_FAILED'

export const getTimelineByProduct = function (productId) {
  return function (dispatch) {
    dispatch({
      type: GET_TIMELINE_BY_PRODUCT_REQUEST
    })
    api.getTimelineByProduct(productId).then(getTimelineByProductResponse => {
      dispatch({
        type: GET_TIMELINE_BY_PRODUCT_SUCCESS,
        payload: getTimelineByProductResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_TIMELINE_BY_PRODUCT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/statistics/get-product-timeline.js